module.exports = __webpack_public_path__ + "img/card-banner.7f81879d.png";